import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    minWidth: 'max-content',
  },
  card: {
    border: 'none',
    borderRadius: 4,
    width: 'fit-content',
  },
  icon: {
    fontSize: 20,
  },
  label: {
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

export default styles
